import React from "react";
import Sections from "./partials/Sections";
import Label from "./partials/Label";
import ChartMetrics from "./partials/ChartMetrics";
import {IGridConfigItem} from "../../../constants/interfaces";
import PaidType from "./partials/PaidType";
import Referrers from "./partials/Referrers";
import VideoFilter from "./partials/VideoFilter";
import PostedOnChannel from "./partials/PostedOnChannel";
import Tags from "./partials/Tags";
import ConversionFilter from "./partials/ConversionFilter";
import PageType from "./partials/PageType";
import PubDateTimeWindow from "./partials/PubDateTimeWindow";
import UserNeeds from "./partials/UserNeeds";
import useCurrentBrandsBigscreenSettings from "../../../hooks/useCurrentBrandsBigscreenSettings";

type Props = {
    item: IGridConfigItem,
    updateConfig: Function,
    isEdit: boolean,
    removeItem: React.MouseEventHandler<HTMLButtonElement>,
    id: number
}

const Chart = (props: Props) => {
    const currentBigscreenSettings = useCurrentBrandsBigscreenSettings(props.item.brands);

	const item = props.item;
    const metric = props.item.graph_metric;

    return (
        <div>
            <h2>Chart</h2>
            <ChartMetrics 
                updateConfig={props.updateConfig} 
                bigscreenSettings={currentBigscreenSettings}
                initialEventFields={props.item.event_fields}
                initialValue={metric} 
            />

            <div className="config-item__selects">
                <PubDateTimeWindow
                    updateConfig={props.updateConfig}
                    pubDateInterval={props.item.pubdate_interval}
                />
				<UserNeeds
					updateConfig={props.updateConfig}
					userNeedValues={props.item.user_needs}
				/>
            </div>
            
			<Sections
				updateConfig={props.updateConfig}
                sections={item.sections}
				brands={item.brands}
				type={item.graph_metric === "videoviews" ? "videos" : "feed"}
				isEdit={props.isEdit}
				cellId={props.item.cell_id}
                id={props.id}
			/>

            <div className="config-item__selects">
                <Tags
                    updateConfig={props.updateConfig}
                    tags={props.item.tags}
                    brands={props.item.brands}
                    type={item.graph_metric === "videoviews" ? "videos" : "feed"}
                    isEdit={props.isEdit}
                    isDisabled={props.item.brands.length === 0}
                    cellId={props.item.cell_id}
                    id={props.id}
                />
                <ConversionFilter
                    updateConfig={props.updateConfig}
                    conversions={props.item.conversions}
                    brands={props.item.brands}
                    type="feed"
                    isEdit={props.isEdit}
                    isDisabled={props.item.brands.length === 0}
                    cellId={props.item.cell_id}
                    id={props.id}
                />
            </div>
            
            <Referrers
                updateConfig={props.updateConfig}
                referrerTypes={props.item.referrer_types}
                referrers={props.item.referrers}
                brands={props.item.brands}
                isEdit={props.isEdit}
                isDisabled={props.item.graph_metric !== 'views' || props.item.brands.length === 0}
                cellId={props.item.cell_id}
                id={props.id}
            />

            <div className="config-item__selects">
                <PaidType updateConfig={props.updateConfig} value={props.item.paid_type} />
                <VideoFilter updateConfig={props.updateConfig} value={props.item.video_filter} />
                <PageType updateConfig={props.updateConfig} value={props.item.page_type} />
            </div>
            
            <PostedOnChannel
                isEdit={props.isEdit}
                postedOnChannels={props.item.posted_on_channels}
                updateConfig={props.updateConfig}
            />

            <Label updateConfig={props.updateConfig} value={item.label}/>

            <button
                className="btn btn-outline-danger remove-item"
                onClick={props.removeItem}
            >
                Remove
            </button>
        </div>
    );
};

export default Chart;
